import { module } from 'modujs';
import { html } from "../utils/environment";

export default class extends module {
    constructor(m) {
        super(m);

        this.$toggler = this.el;
        this.$projets = document.querySelector('.c-projet_details');
        this.$carousel = document.querySelector('.c-slider');


        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }
    toggle(e) {
        if (!e.curTarget.classList.contains('is-active')) {
            this.$toggler.classList.add('is-active')
            this.$projets.classList.add('is-shown')

            if (this.$carousel) {
                html.classList.add('is-transitioning')

                setTimeout(() => {
                    this.call('destroy', null, 'Carousel')
                    this.$carousel.classList.add('is-tiny')
                }, 450)

                setTimeout(() => {
                    this.call('init', null, 'Carousel')
                    html.classList.remove('is-transitioning')
                    const scrollDiv = document.querySelector('.c-projet_infos')
                    const header = document.querySelector('#header')
                    const y = scrollDiv.getBoundingClientRect().top - (header.offsetHeight * 0.6)
                    window.scrollTo({ top: y, behavior: 'smooth' })
                }, 550)
            }
        } else {
            this.$toggler.classList.remove('is-active')

            if (this.$carousel) {
                html.classList.add('is-transitioning')

                setTimeout(() => {
                    this.call('destroy', null, 'Carousel')
                    this.$carousel.classList.remove('is-tiny')
                }, 450)

                setTimeout(() => {
                    this.call('init', null, 'Carousel')
                    this.$projets.classList.remove('is-shown')
                    html.classList.remove('is-transitioning')
                }, 550)
            }
        }
    }
}
